import { hexToRgb } from './hexToRgb';

export const hexToRgbaString = (hex: string, opacity = 1) => {
  const { r, g, b } = hexToRgb(hex);
  return `rgba(${r},${g},${b},${opacity})`;
};
